var React = require('react');

function IconDrop (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.91481 14.2082C6.4039 14.2082 4.78268 11.5514 5.93104 9.31845L7.44496 6.33951C8.0306 5.18716 9.67027 5.16899 10.2813 6.30809L11.9329 9.38705C13.0153 11.6155 11.3922 14.2082 8.91481 14.2082ZM4.86389 8.76963C3.30482 11.8012 5.50587 15.4082 8.91481 15.4082C12.2783 15.4082 14.4818 11.8882 13.0123 8.86276L10.2397 3.15449C9.74183 2.12947 8.28739 2.11284 7.76622 3.12622L4.86389 8.76963Z","fill":"#001D3B","stroke":"#001D3B","strokeWidth":"0.5","strokeLinecap":"round"}));
}

IconDrop.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = IconDrop;

IconDrop.default = IconDrop;
